// GS-0171 step 7: the small count beside Outbox in the GenServ left menu: messages waiting for a person to approve (queued, nobody approved yet; the same definition the Action Center uses).
// Read only: one head count, refreshed when the app comes back to the foreground. It shows nothing when the count is 0 or cannot be read (never a guess), and it is not a control.
import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';
import { GENSERV_PARTNER_ID } from '../../lib/genservShell';

export async function readWaitingCount() {
  try {
    const { count, error } = await supabase.from('genserv_outbox').select('id', { count: 'exact', head: true })
      .eq('partner_id', GENSERV_PARTNER_ID).eq('status', 'queued').is('approved_at', null);
    return error || typeof count !== 'number' ? null : count;
  } catch (e) { return null; }
}

export default function OutboxMenuBadge() {
  const [n, setN] = useState(null);
  useEffect(() => {
    let live = true;
    const load = async () => { const c = await readWaitingCount(); if (live) setN(c); };
    load();
    const onShow = () => { if (document.visibilityState === 'visible') load(); };
    document.addEventListener('visibilitychange', onShow);
    return () => { live = false; document.removeEventListener('visibilitychange', onShow); };
  }, []);
  if (!n) return null;
  return <span data-testid="outbox-menu-badge" role="status" aria-label={`${n} waiting for approval`} style={{ minWidth: 18, height: 18, padding: '0 5px', borderRadius: 9, background: 'var(--gov-info, #1d4ed8)', color: '#fff', fontSize: 11, fontWeight: 700, lineHeight: '18px', textAlign: 'center', boxSizing: 'border-box' }}>{n > 99 ? '99+' : n}</span>;
}
